"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ViewType;
(function (ViewType) {
    ViewType["FULL"] = "full";
    ViewType["BREAKDOWN"] = "breakdown";
})(ViewType = exports.ViewType || (exports.ViewType = {}));
